<div class="rc-view-actions-bar-shell d-flex flex-column shadow-sm rounded-2 border cursor-pointer">
  <app-map-navigation-item>
    <span
      class="rb-ic rb-ic-alert-info fs-2xl hover-effect p-2 rounded-2"
      [class.sel-menu-item]="isLegendVisible"
      (click)="toggleLegend.emit()"
      placement="start"
      ngbTooltip="Show legend"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
    >
    </span>
  </app-map-navigation-item>
</div>
